import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ITicketParameter, TicketParameter, ITicketListingViewModel } from '../../../../models/ticket';
//@ts-ignore
import { StateTypes, ActivityStatus } from '@/common/enums';
import { namespace } from 'vuex-class';
//@ts-ignore
import { BLOCK_MODULE_NAMESPACE, BLOCK_APARTMENT_SIDEBAR_GET_TICKETS } from '@/store/block';

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'list-item': async () => import('@/containers/ticket/components/ticket-list-item/TicketListItem.vue')
  }
})
class BlockTanentTickets extends Vue {

  dtAcitivityStatus: ActivityStatus

  @Prop({ default: () => new TicketParameter({ state: [StateTypes.InProgress] }) })
  parameter: ITicketParameter;

  @BlockStore.Getter currentBlockId: number;
  @BlockStore.Getter blockApartmentInProcessTickets: ITicketListingViewModel[];


  @BlockStore.Action(BLOCK_APARTMENT_SIDEBAR_GET_TICKETS)
  storeGetTickets: (payload: {
    ticketParameter: ITicketParameter,
    storeKey?: string
  }) => Promise<ITicketListingViewModel[]>


  dtTicketParameter: ITicketParameter;
  /**
   *
   */
  constructor() {
    super();
    this.dtAcitivityStatus = ActivityStatus.NoActivity;
  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/block').default
    }
  }

  get blockId(): number[] {
    return [parseInt(this.$route.params.id)]
  }

  get apartmentId(): number {
    return parseInt(this.$route.params.cid);
  }
  get ticketPameter(): ITicketParameter {
    return new TicketParameter({
      // state: [StateTypes.InProgress]
    })
  }
  get isLoading(): boolean {
    console.log(this.dtAcitivityStatus, 'dtAcitivityStatus')
    return this.dtAcitivityStatus === ActivityStatus.Loading;
  }
  mounted() {
    this.handleLoadTickets();
  }

  private async handleLoadTickets() {
    this.dtAcitivityStatus = ActivityStatus.Loading;
    this.storeGetTickets({
      ticketParameter: this.ticketPameter,
      storeKey: 'blockApartmentInProcessTickets'
    })
      .then(response => {
        this.dtAcitivityStatus = ActivityStatus.Loaded;
        console.log(response, 'response')
        console.log(this.dtAcitivityStatus, response, 'dtAcitivityStatus')
      })
      .catch(err => {
        this.dtAcitivityStatus = ActivityStatus.LoadFailed;
        console.log(err)
      })
  }
}

export default BlockTanentTickets;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-tenant-tickets/index.ts